import React from 'react';
import { Link } from 'react-router-dom';
const links = [['#platform', 'Platform'], ['#gone-fishing', 'Gone Fishing'], ['#pricing', 'Pricing'], ['/brand', 'Brand Portal'], ['/investor', 'Investor'], ['#start', 'Contact']];
export function Footer() {
  return <footer className="bg-black px-5 py-12 text-white md:px-10" data-id="element-404">
      <div className="mx-auto max-w-[1280px]" data-id="element-405">
        <div className="grid gap-10 md:grid-cols-[1fr_1fr]" data-id="element-406">
          <div data-id="element-407">
            <Link to="/" className="font-display text-3xl font-bold" data-id="element-408">
              SAMPLER
            </Link>
            <p className="mt-4 max-w-xs text-lg leading-relaxed text-white/70" data-id="element-409">
              The product experience platform.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-y-4 text-sm font-bold" aria-label="Footer navigation" data-id="element-410">
            {links.map(([href, label]) => href.startsWith('/') ? <Link key={label} to={href} className="text-white/75 hover:text-white" data-id="element-411">
                  {label}
                </Link> : <a key={label} href={href} className="text-white/75 hover:text-white" data-id="element-412">
                  {label}
                </a>)}
          </nav>
        </div>
        <div className="mt-16 border-t border-white/15 pt-7 md:flex md:items-end md:justify-between" data-id="element-413">
          <p className="font-display text-2xl font-bold leading-tight md:text-3xl" data-id="element-414">
            Advertising interrupts experiences.
            <br data-id="element-415" />
            <span className="text-[#ff4d17]" data-id="element-416">We turn brands into them.</span>
          </p>
          <p className="mt-8 text-xs font-bold text-white/55 md:mt-0" data-id="element-417">
            © 2026 SAMPLER
          </p>
        </div>
      </div>
    </footer>;
}